// extracted by mini-css-extract-plugin
export default {"container":"osDkXE","shopeePayLegacyContainer":"AhnL_X"};